import { Box as UiBox } from "@logora/parliament.ui.box";
import React from "react";
import styles from "./AgendaShow.module.scss";
import { Calendar } from "./Calendar";

export const AgendaShow = () => {
	return (
		// <div className={styles.container}>
		// 	<UiBox title="Agenda">
				<Calendar />
		// 	</UiBox>
		// </div>
	);
};
